import React, { useState, useEffect } from 'react';
import Amplify, { Auth } from 'aws-amplify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faCircle,
  faCheckCircle,
  faPlus,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router';
import batchImg from '../../assets/images/challenge-banner.png';
import { useHistory } from 'react-router-dom';
import { cx, css } from '@emotion/css';
import * as styles from './challanges.style.js';
import { selectMedium } from '../../styles/components/forms.style';
import Select from 'react-select';
import { find } from 'lodash';

var Studentmap = {};

const pageWrapper = css`
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  background: #fdfbf7;
`;

const cardStyles = css`
  position: relative;
  width: 100%;
  max-width: 640px;
  background: linear-gradient(160deg, #fff9f4 0%, #fdfbf7 100%);
  border-radius: 24px;
  border: 1.5px solid rgba(241, 102, 2, 0.2);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.6) inset;
  padding: 40px;
  font-family: 'Inter', sans-serif;
`;

const headerTitleStyles = css`
  font-size: 2rem;
  font-weight: 800;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 32px;
  margin-top: 0;
  span { background: linear-gradient(90deg, #f16602, #ff8c42); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
`;

const inputStyles = css`
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(241,102,2,0.25);
  background: #fff;
  font-size: 0.95rem;
  font-family: 'Inter', sans-serif;
  color: #333;
  transition: all 0.2s;
  box-sizing: border-box;
  &:focus { outline: none; border-color: #f16602; box-shadow: 0 0 0 3px rgba(241,102,2,0.15); }
`;

const formRow = css`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  > * { flex: 1; min-width: 200px; }
`;

const labelStyle = css`
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #666;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const btnFlex = css`
  display: flex;
  gap: 16px;
  margin-top: 36px;
  @media (max-width: 600px) { flex-direction: column; }
`;

const submitBtnStyle = css`
  flex: 1;
  padding: 16px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #f16602 0%, #d94f00 100%);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(241, 102, 2, 0.38);
  transition: transform 0.18s, box-shadow 0.18s;
  text-transform: uppercase;
  letter-spacing: 1px;
  &:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(241, 102, 2, 0.48); }
`;

const cancelBtnStyle = css`
  flex: 1;
  padding: 16px;
  border-radius: 12px;
  border: 1.5px solid rgba(241, 102, 2, 0.3);
  background: transparent;
  color: #d94f00;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s;
  text-transform: uppercase;
  letter-spacing: 1px;
  &:hover { background: rgba(241, 102, 2, 0.08); border-color: #f16602; }
`;

const totalTimeBar = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, rgba(241,102,2,0.12), rgba(255,200,100,0.08));
  border: 1px solid rgba(241,102,2,0.2);
  border-radius: 12px;
  padding: 12px 18px;
  margin-top: 16px;
  grid-column: 1 / -1;

  span:first-child {
    font-size: 0.88rem;
    font-weight: 600;
    color: #4a4a4a;
  }
  span:last-child {
    font-size: 0.95rem;
    font-weight: 800;
    color: #f16602;
  }
`;

const formatTimeDisplay = (seconds) => {
  if (seconds === 0) return 'No time limit';
  if (seconds >= 60) {
    const m = seconds / 60;
    return `${m === Math.floor(m) ? m : m.toFixed(1)} min`;
  }
  return `${seconds} sec`;
};

const formatTotalTime = (seconds) => {
  if (seconds === 0) return 'No time limit';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m > 0 && s > 0) return `${m} min ${s} sec`;
  if (m > 0) return `${m} min`;
  return `${s} sec`;
};

const bannerStyle = css`
  width: 100%;
  border-radius: 16px;
  margin-bottom: 32px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0,0,0,0.1);
  border: 1px solid rgba(255,255,255,0.6);
  img { width: 100%; height: auto; display: block; object-fit: cover; }
`;


function EditChallenge(props) {
  const categorytypes = [
    'Mathematics',
    'General Knowledge',
    'Chess',
    'SpellBowl',
  ];

  const history = useHistory();
  const [jwt, set_jwt] = useState('');
  const [email, set_Email] = useState('');
  const [username, set_username] = useState('');
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState('');
  const [level, setLevel] = useState('');
  const [levels, setLevels] = useState([]);
  const [limits, setLimits] = useState([]);

  const [id, setID] = useState('');
  const [batches, setBatches] = useState([]);

  const [totalquestions, set_totalquestions] = useState(0);
  const [totalquestions_old, set_totalquestions_old] = useState(0);

  const [maxnoofparticipants, set_maxnoofparticipants] = useState(50000);


  const [timeforassignment, setTimeforassignment] = useState(0);

  const [name, setName] = useState('');

  const [batchname, setBatchname] = useState('');
  const [specificcategory, set_specificcategory] = useState([]);
  const [eventtype, set_eventtype] = useState('');
  const [eventdisplay, set_eventdisplay] = useState('');

  const [inputValue, setInputValue] = useState('');
  const [status, setStatus] = useState('Save Details');

  const [checks, setChecks] = useState('');
  const timeOptions = [0, 5, 10, 15, 30, 45, 60, 90, 120, 180, 300];
  const noofquestionsoptions = [2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

  let data1 = useLocation();
  let oldquestionn = 0

  function getEquallyNumbArray(number, numberOfSplit) {

    // console.log(number)
    // console.log(numberOfSplit)
    // console.log(typeof number)
    // console.log(typeof numberOfSplit)

    if (
      numberOfSplit > number ||
      typeof number !== 'number' ||
      typeof numberOfSplit !== 'number'
    ) {
      throw new Error('invalid arguments');
    }

    const result = [];

    for (let i = 1; i <= numberOfSplit; i++) {
      result.push(Math.floor(number / numberOfSplit));
    }

    const sumOfResult = result.reduce((a, b) => {
      return a + b;
    }, 0);

    if (sumOfResult === number) return result;

    const remainder = number - sumOfResult;
    const resultLength = result.length;

    if (remainder === 1) {
      result[resultLength - 1] = result[resultLength - 1] + remainder;
    } else {
      for (let i = remainder; i > 0; i--) {
        result[resultLength - i] = result[resultLength - i] + 1;
      }
    }

    return result;
  }



  useEffect(() => {
    setName(data1.state['name']);
    setCategory(data1.state['category']);
    setLevel(data1.state['level']);
    setID(data1.state['id']);
    set_totalquestions_old(data1.state['totalquestions'])
    set_totalquestions(data1.state['totalquestions']);
    setTimeforassignment(data1.state['time']);
    set_eventtype(data1.state['eventtype']);
    set_specificcategory(data1.state['specificcategory']);
    setLevels(data1.state['levels']);
    setLimits(data1.state['limits']);
    set_eventdisplay(data1.state['eventdisplay']);
    set_maxnoofparticipants(data1.state['maxnoofparticipants']);
    getToken();


    document.title = 'Edit Challenge';




  }, []);

  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log("Auth.currentSession()")
  //     let accessToken = res.getAccessToken();
  //     ////console.log("accessToken called ")
  //     let jwt = accessToken.getJwtToken();

  //     ////console.log("Got jwt ")
  //     let useremail = Auth.user.attributes.email;
  //     let username = Auth.user.username;

  //     set_jwt(jwt);
  //     set_Email(useremail);
  //     set_username(username);
  //     getBatches(username, jwt);
  //   });
  // };


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        set_jwt(jwt);
        set_Email(user.attributes['email']);


        if (user.username.includes("Google_")) {

          set_username(user.attributes['email']);
          getBatches(user.attributes['email'], jwt);





        }
        else {

          set_username(user.username);
          getBatches(user.username, jwt);



        }





      });




    } catch (error) {
      // console.log(error)
      Auth.signOut();
    }
  };







  const createEvent = async () => {



    setStatus('Saving.....');
    var requestOptions = {};
    // console.log(specificcategory)
    // console.log(totalquestions)
    // console.log("we should use these numbers to find the array")

    // console.log(getEquallyNumbArray(totalquestions, specificcategory.length))

    requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        appname: 'QuizWhiz',
        category: category,
        completed: 0,
        description: category,
        eventenddate: '2081-01-31',
        eventowner: username,
        eventstartdate: '2011-01-31',
        eventstarted: 0,
        eventtype: eventtype,
        id: id,
        level: parseInt(level),
        levels: levels,
        limits: getEquallyNumbArray(totalquestions, specificcategory.length),
        //      limits: getEquallyNumbArray(parseInt(totalquestions), specificcategory.length),
        maxnoofparticipants: maxnoofparticipants,
        minnoofparticipants: 1,
        name: name,
        points: 0,
        qualificationno: totalquestions,
        rewards: '',
        subcategory: name,
        time: timeforassignment,
        totalquestions: totalquestions,
        email: email,
        active: true,
        noofretries: 0,
        premiumevent: 0,
        parent: id,
        eventdisplay: eventdisplay,
        sendEmail: true,
        specificcategory: specificcategory,
        complexity: 1,
      }),
    };

    ////console.log(requestOptions)
    const response = await fetch(
      `https://api.quizwizard.net/quiz/createevent`,
      requestOptions
    );
    const data = await response.json();

    alert('Successfully Updated');
    setStatus('Save Details');
  };
  const getBatches = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };
    const response = await fetch(
      `https://api.quizwizard.net/quiz/listbatchesbyowner`,
      requestOptions
    );
    const data = await response.json();
    var i, j;
    var loopData = [];
    var batches1 = [];
    var count = 0;

    for (i = 0; i < data.length; i++) {
      //////console.log(data[i]['events'][0])
      for (j = 0; j < data[i]['events'].length; j++) {
        //////console.log(data[i]['events'][j])
        loopData[count] = data[i]['events'][j];
        ////console.log("loopData[count]")
        ////console.log(loopData[count])
        var obj = {
          batchname: loopData[count]['name'],
          id: loopData[count]['id'],
        };
        ////console.log(obj)
        batches1[count] = obj;
        count = count + 1;
      }
    }

    setBatches(batches1);

    // set_batches(loopData)
    // set_loadedevents(true)
  };

  const getuserDetails = async (username) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };

    const response = await fetch(
      `https://api.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();

    if (data != 'No User') {
      const newItem = inputValue;
      const newItems = [...items, newItem];
      setItems(newItems);
      setInputValue('');
      Studentmap[inputValue] = 'add';
    } else {
      alert('Username not valid. Please verify');
      setInputValue('');
    }
  };

  const createBatch = async (
    category,
    id,
    members,
    batchname,
    username,
    useremail,
    jwt
  ) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },

      body: JSON.stringify({
        category: category,
        classowner: username,
        id: id,
        name: batchname,
        email: useremail,
        sendEmail: true,
        members: members,
      }),
    };

    const response = await fetch(
      `https://api.quizwizard.net/quiz/createbatch`,
      requestOptions
    );
    const data = await response.json();
  };
  function goback() {
    history.goBack();
  }
  // HINT: each "item" in our list names a name,
  // a boolean to tell if its been completed, and a quantity
  // const [items, setItems] = useState([
  // 	{ itemName: 'Student1', quantity: 1, isSelected: false },
  // 	{ itemName: 'Student2', quantity: 3, isSelected: false },
  // 	{ itemName: 'Student3', quantity: 2, isSelected: false },
  // ]);

  const handleAddButtonClick = () => {
    getuserDetails(inputValue);
  };

  const deleteStudent = (index) => {
    Studentmap[items[index]] = 'remove';
    const newItems = [...items];
    newItems.splice(index, 1);

    //newItems[index].isSelected = !newItems[index].isSelected;

    setItems(newItems);
    //setTotalItemCount(items.length - 1 );
  };

  const selectedBatch = find(batches, { id: level }) || {};

  return (
    <div className={pageWrapper}>
      <div className={cardStyles}>
        {checks}
        <div className={bannerStyle}>
          <img src={batchImg} alt="Challenge Banner" />
        </div>
        
        <h3 className={headerTitleStyles}>Edit <span>Challenge</span></h3>
        
        <div style={{ marginBottom: 20 }}>
          <label className={labelStyle}>Event Name</label>
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            className={inputStyles}
            placeholder="e.g. Weekly Math Challenge"
          />
        </div>
        
        <div style={{ marginBottom: 24 }}>
          <label className={labelStyle}>Batch Name</label>
          <Select
            name="level"
            className={selectMedium}
            classNamePrefix="select"
            value={{ value: selectedBatch.id, label: selectedBatch.batchname }}
            options={batches.map((batch) => ({
              label: batch.batchname,
              value: batch.id,
            }))}
            onChange={(e) => setLevel(e.value)}
          />
        </div>
        
        <div className={formRow}>
          <div>
            <label className={labelStyle}>No. of Questions</label>
            <Select
              name="noofquestions"
              className={selectMedium}
              placeholder="No of Questions"
              classNamePrefix="select"
              value={{ value: totalquestions, label: totalquestions }}
              options={noofquestionsoptions.filter(ques => ques >= totalquestions_old).map((times) => ({
                label: times,
                value: times,
              }))}
              onChange={(e) => set_totalquestions(e.value)}
            />
          </div>
          <div>
            <label className={labelStyle}>Time per question</label>
            <Select
              name="timeforassigments"
              className={selectMedium}
              placeholder="Time per question"
              classNamePrefix="select"
              value={{
                value: timeforassignment,
                label: formatTimeDisplay(timeforassignment),
              }}
              options={timeOptions.map((times) => ({
                value: times,
                label: formatTimeDisplay(times),
              }))}
              onChange={(e) => setTimeforassignment(e.value)}
            />
          </div>
        </div>

        <div className={totalTimeBar}>
          <span>Total Session Time</span>
          <span>{formatTotalTime(timeforassignment * (parseInt(totalquestions) || 0))}</span>
        </div>
        
        <div className={btnFlex}>
          <button className={submitBtnStyle} onClick={createEvent}>
            {status}
          </button>
          <button className={cancelBtnStyle} onClick={goback}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditChallenge;